import styled from "styled-components";

export const TimeLabel = styled.div`
  grid-column: span 1 / auto;
  font-variant-numeric: tabular-nums;
  user-select: none;
`;
